
import Button from "../../components/buttons/Button.vue";
import Input from "../../components/form/Input.vue";
import Modal from "../../components/Modal.vue";
import { registerAnimation } from "../../animations/registerAnimation";
import { onMounted, defineComponent } from "vue";
import { useField, useForm } from "vee-validate";
import { registerSchema } from "../../utils/validationSchemas";
import { useUser, RegisterData } from "../../utils/composable/useUser";

export default defineComponent({
  components: {
    Button,
    Input,
    Modal,
  },
  setup() {
    const { handleSubmit, errors } = useForm({
      validationSchema: registerSchema,
    });

    const { value: name } = useField("name");
    const { value: email } = useField("email");
    const { value: password } = useField("password");
    const { value: confirmPassword } = useField("confirmPassword");

    const { register } = useUser();

    const handleRegister = handleSubmit((data, { resetForm }) => {
      resetForm();
      return register(data as RegisterData);
    });

    onMounted(() => {
      registerAnimation();
    });

    return { errors, handleRegister, name, email, password, confirmPassword };
  },
});
